import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { OrderResult } from "@/pages/Success";
import { api } from "@/lib/api";

export default function PayPalSuccess() {
  const [params] = useSearchParams();
  const orderId = params.get("token");
  const [state, setState] = useState("checking");
  const [data, setData] = useState(null);
  const started = useRef(false);

  useEffect(() => {
    if (!orderId) {
      setState("error");
      return;
    }
    if (started.current) return;
    started.current = true;
    api
      .post("/paypal/capture", { order_id: orderId })
      .then((r) => {
        setData(r.data);
        setState("paid");
      })
      .catch(() => setState("error"));
  }, [orderId]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="paypal-success-page">
      <OrderResult state={state} data={data} sessionId={orderId} />
    </div>
  );
}
